// extracted by mini-css-extract-plugin
export var footerContainer = "Footer-module--footerContainer--45249";
export var footerLogo = "Footer-module--footerLogo--3f281";
export var links = "Footer-module--links--340d0";
export var root = "Footer-module--root--d2ef2";
export var social = "Footer-module--social--a973c";